const BlogsDetails = [
  {
    id: 23,
    title: "Why Natural Ingredient Cakes Are Better Than Processed Cakes",
    description:  "Cakes have evolved from simple homemade treats to mass-produced desserts available everywhere. While processed cakes dominate shelves due to convenience and long shelf life, many customers today are shifting toward natural ingredient cakes that focus on simplicity and freshness...",
    image: "/images/product/cake-3.jpeg",
    path:"natural-ingredient-cakes-vs-processed-cakes",
    published:"05 Apr 2026"
  },
  {
    id: 22,
    title: "How to Order Fresh Whole Wheat Cakes Online in Chennai",
    description:  "Ordering cakes online has become the most convenient way to celebrate special moments. But when it comes to cakes made with better ingredients and fresh baking methods, knowing how to choose the right bakery matters.If you’re searching for whole wheat cakes online in Chennai, this guide will help...",
    image: "/images/product/cake-2.jpeg",
    path:"order-whole-wheat-cakes-online-chennai",
    published:"30 Apr 2026"
  },
  {
    id: 21,
    title: "Natural & Eggless Cakes in Chennai: Why They’re Gaining Popularity",
    description:  "In recent years, dessert preferences in Chennai have seen a noticeable shift. More customers are choosing cakes that align with their lifestyle, ingredient preferences, and baking expectations. Among these, eggless cakes Chennai searches have grown significantly, along with rising interest...",
    image: "/images/home/cupcake.jpg",
    path:"natural-eggless-cakes-chennai",
    published:"28 Apr 2026"
  },
  {
    id: 20,
    title: "Whole Wheat Cakes for Kids: Are They Safe and Nutritious?",
    description:  "When it comes to children, parents are more mindful than ever about the ingredients used in everyday foods, including cakes. Birthdays, school events, and small celebrations often include desserts, which raises an important question: are whole wheat cakes suitable for kids?",
    image: "/images/home/slicecake.png",
    path:"whole-wheat-cakes-for-kids",
    published:"18 Apr 2026"
  },
  {
    id: 19,
    title: "How We Make 100% Whole Wheat Cakes Without Preservatives?",
    description:  "Cakes made with whole wheat and clean ingredients require a different approach compared to conventional baking. At WheatBakes, every step from ingredient selection to baking and delivery  is designed to ensure freshness, flavour, and consistency without relying on artificial shortcuts...",
    image: "/images/product/cake-4.jpeg",
    path:"whole-wheat-cakes-without-preservatives",
    published:"15 Apr 2026"
  },
  {
    id: 18,
    title: "No Artificial Flavours Bakery: What Makes a Cake Truly Clean and Natural?",
    description:  "Cakes today are not just about appearance and sweetness; more customers are paying attention to what goes into them. Terms like “natural” and “clean baking” are becoming common, but not every bakery follows these principles in practice. This is why many people...",
    image: "/images/product/cake-3.jpeg",
    path:"no-artificial-cakes-flavours-bakery",
    published:"12 Apr 2026"
  },
  {
    id: 17,
    title: "Vegetarian Cakes and Desserts: Natural Eggless Options Explained",
    description:  "Dessert preferences in Chennai are evolving, with more people choosing options that match their lifestyle and ingredient preferences. Among these, vegetarian cakes and desserts have become a popular choice for both everyday treats and celebrations.Eggless...",
    image: "/images/product/cake-1.jpeg",
    path:"vegetarian-cakes-and-desserts",
    published:"08 Apr 2026"
  },
    {
      id: 16,
      title: "No Artificial Flavours Bakery: What Makes a Cake Truly Clean and Natural?",
      description:  "Cakes today are not just about appearance and sweetness; more customers are paying attention to what goes into them. Terms like “natural” and “clean baking” are becoming common, but not every bakery follows these principles in practice...",
      image: "/images/product/cake-2.jpeg",
      path:"no-artificial-flavours-bakery",
      published:"03 Apr 2026"
    },
    {
      id: 15,
      title: "Vegetarian Cakes and Desserts: Tasty Natural Eggless Options Explained",
      description:  "Dessert choices are evolving as more people look for options that match their preferences and lifestyle. Among these, vegetarian cakes and desserts have become increasingly popular, especially in cities like Chennai, where eggless baking is widely preferred. From celebration cakes to everyday treats, eggless...",
      image: "/images/home/teacakes.png",
      path:"vegetarian-cakes-desserts",
      published:"30 Mar 2026"
    },
    {
      id: 14,
      title: "Gluten-Free Brownies and Muffins: Are They Better Than Wheat-Based Ones?",
      description:  "Baking preferences are evolving as more people explore alternatives to traditional wheat-based desserts. Among the most popular options are Gluten-Free brownies and Muffins, which are now widely available in modern bakeries...",
      image: "/images/mc-1.png",
      path:"gluten-free-vs-wheat-brownies-muffins",
      published:"24 Mar 2026"
    },
    {
      id: 13,
      title: "Homemade Style Natural Cakes: Why Texture and Ingredients Matter",
      description:  "Many cake lovers today prefer desserts that feel closer to home-baking rather than factory-style production. This growing interest has led to the popularity of homemade-style natural cakes, where texture, ingredient quality, and fresh preparation play a central role. When people search for the best cakes...",
      image: "/images/product/wheat-cakes.jpg",
      path:"homemade-style-natural-cakes",
      published:"18 Mar 2026"
    },
    {
      id: 12,
      title: "Whole Wheat Cakes with Millet Brownie and Traditional Rice Brownie Delivery in Chennai",
      description: "Dessert preferences in Chennai are evolving. More people are choosing baked goods made with traditional grains instead of refined flour. Among these, whole wheat cakes, millet brownies, and traditional rice brownie cakes are becoming popular...",
      image: "/images/home/celebrationcakes.jpg",
      path:"grain-based-cakes-brownies-chennai",
      published:"03 Mar 2026"
    },
    {
      id: 11,
      title: "Natural vs Commercial Bakery Cakes",
      description: "Cakes are no longer just about looks and sweetness. More customers today are paying attention to ingredients, baking methods, and freshness. This has led to an increasing comparison between natural ingredient cakes and mass-produced commercial bakery cakes....",
      image: "/images/home/cheesecake.png",
      path:"natural-vs-commercial-bakery-cakes",
      published:"01 Mar 2026"
    },
    {
      id: 10,
      title: "Wheat-Based Cookies and Pastries",
      description: "Snacking habits are changing as more people pay attention to ingredients, freshness, and baking methods. Instead of heavily processed options, many customers now prefer snacks made with simple grains and traditional baking techniques...",
      image: "/images/product/cup_cakes.jpg",
      path:"wheat-based-cookies-and-pastries",
      published:"24 Feb 2026"
    },
    {
      id: 9,
      title: "Maida Free Whole Wheat Cakes in Chennai T Nagar",
      description: "Desserts are meant to be enjoyed, but many people today prefer cakes made with better ingredients and thoughtful baking methods. If you’re searching for the best cakes in Chennai T Nagar, maida-free whole wheat cakes...",
      image: "/images/product/cakes2.jpg",
      path:"maida-free-whole-wheat-cakes-in-chennai",
      published:"16 Feb 2026"
    },
    {
      id: 8,
      title: "Natural Bakery In Chennai",
      description: "As customers become more aware of what goes into their food, the demand for clean, natural baking is growing. Many people are now searching for a natural bakery in Chennai that focuses on quality ingredients...",
      image: "/images/product/alwarpet-store.jpeg",
      path:"natural-bakery-in-chennai",
      published:"08 Feb 2026"
    },
    {
      id: 7,
      title: "Zero Sugar Natural Cakes",
      description: "With growing awareness around ingredient quality, zero sugar cakes are gaining attention. Many people now wonder whether zero sugar natural cakes are genuinely better or simply another marketing trend...",
      image: "/images/product/fruit_cakes.jpg",
      path:"zero-sugar-natural-cakes",
      published:"04 Feb 2026"
    },
    {
      id: 6,
      title: "Natural Birthday Cakes In Chennai",
      description: "Birthday celebrations are moments of joy, togetherness, and indulgence. But today, more families are looking beyond just appearance and taste  they want cakes that are natural, safer, and made with clean ingredients...",
      image: "/images/home/plaincake.png",
      path:"natural-birthday-cakes-in-chennai",
      published:"18 Jan 2026"
    },
    {
      id: 5,
      title: "Maida-Free Cakes: Why Refined Flour Is Best Avoided?",
      description: "Cakes are a part of celebrations, comfort moments, and everyday indulgence. However, not all cakes are created equal. Most traditional cakes are made using refined flour, commonly known as maida. While maida cakes may taste soft..",
      image: "/images/a-3.jpg",
      path:"maida-free-cakes-why-refined-flour-is-best-avoided",
      published:"13 Jan 2026"
    },
    {
      id: 4,
      title: "Whole Wheat Cakes Online: How to Choose the Healthiest Option?",
      description: "Ordering cakes online has become incredibly convenient, but choosing a natural cake requires more than just picking the best-looking option. With growing awareness around nutrition, many people are now searching for whole wheat cakes online....",
      image: "/images/home/jarcake.png",
      path:"how-to-choose-the-healthiest-option",
      published:"06 Jan 2026"
    },
    {
      id: 3,
      title: "Eggless Whole Wheat Cakes: A Healthy Choice for Families",
      description: "Families are becoming more mindful about desserts, especially for children and elders. Traditional cakes with refined flour and eggs may not suit every household. Eggless whole wheat cakes are a perfect solution. At WheatBakes, we show that cakes...",
      image: "/images/home/teacakes.png",
      path:"eggless-whole-wheat-cakes-a-healthy-choice-for-family",
      published:"26 Dec 2025"
    },
    {
      id: 2,
      title: "Why Whole Wheat Cakes Are Healthier Than Maida Cakes ?",
      description: "In recent years, health-conscious consumers have started questioning what goes into their desserts. Cakes, once considered an occasional indulgence, are now being reimagined with better ingredients and smarter choices...",
      image: "/images/home/cupcake.jpg",
      path:"why-whole-wheat-cakes-are-healthier-than-maida-cakes",
      published:"16 Dec 2025"
    },
    {
      id: 1,
      title: "Celebrate Healthier with Clean Ingredients",
      description: "This is where clean-ingredient cakes step in. With no preservatives, and no artificial additives, they bring the perfect balance of taste, health, and happiness. At WheatBakes, we’re redefining indulgence with cakes that you can enjoy without guilt...",
      image: "/images/home/slicecake.png",
      path:"celebrate-healthier-with-clean-ingredients",
      published:"13 Sept 2025"
    }
  ];

export default BlogsDetails;